module.exports = __webpack_public_path__ + "static/img/card_right.305791c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/card_right.png
// module id = VjHv
// module chunks = 1